import { includes } from "lodash";
import { getBootstrapColorName } from "../../../../utils";

const applyMarketFilters = (marketFilters, data, opItems, defectFilters) => {
  return new Promise((resolve, reject) => {
    let items = [];
    let filteredData = [];
    const accepted_product_types = ["Granel"];

    // Apply accepted product types filter
    data = data.filter((item) => accepted_product_types.includes(item.product_type_name));

    // Apply accepted_certificates filter
    if (marketFilters.accepted_certs.length > 0) {
      for (let i of data) {
        let certificates = i.certificates;
        let acceptedCertificates = marketFilters.accepted_certs;
        let accepted = false;
        for (let j of acceptedCertificates) {
          if (certificates.includes(j)) {
            accepted = true;
          } else {
            accepted = false;
            break; // Si hay uno que no esté se quiebra la iteracion y no se acepta
          }
        }
        if (accepted) {
          filteredData.push(i);
        }
      }
    } else {
      filteredData = data;
    }

    // Apply accepted_vatieties filter
    if (marketFilters.accepted_varieties.length > 0) {
      let filteredData2 = [];
      for (let i of filteredData) {
        let variety = i.variety_name;
        let acceptedVarieties = marketFilters.accepted_varieties;
        if (acceptedVarieties.includes(variety)) {
          filteredData2.push(i);
        }
      }
      filteredData = filteredData2;
    }

    // Apply accepted classifications filter
    if (marketFilters.accepted_classifications.length > 0) {
      let filteredData2 = [];
      for (let i of filteredData) {
        if (i.inspections.length > 0) {
          let classification = i.inspections[0].name;
          let acceptedClassifications = marketFilters.accepted_classifications;
          if (acceptedClassifications.includes(classification)) {
            filteredData2.push(i);
          }
        }
      }
      filteredData = filteredData2;
    }

    // Filtro de accepted_certs con condicion OR
    if (marketFilters.accepted_certs_or && marketFilters.accepted_certs_or.length > 0) {
      let filteredData2 = [];
      for (let i of filteredData) {
        let certificates = i.certificates;
        let acceptedCertificates = marketFilters.accepted_certs_or;
        let accepted = false;
        for (let j of acceptedCertificates) {
          if (certificates.includes(j)) {
            accepted = true;
            break;
          }
        }
        if (accepted) {
          filteredData2.push(i);
        }
      }
      filteredData = filteredData2;
    }

    // Filtro de pallets metidos a mano
    const sidePallets = opItems[0].config["sidePallets"];
    if (sidePallets) {
      const pallets = sidePallets["pallets"];
      if (pallets && pallets.length > 0) {
        for (let i of pallets) {
          filteredData.push(i);
        }
      }
    }

    for (let i = 0; i < filteredData.length; i++) {
      const inspection = filteredData[i].inspections.length > 0 ? filteredData[i].inspections[0] : null;
      const inspectionColor = inspection ? inspection.color : "#ddd";
      const inspectionScore = inspection ? inspection.score : 100;
      const potentialPercentage = (100 - inspectionScore) / 100;
      const potential_kg = filteredData[i].net_kilograms * potentialPercentage;
      const item = {
        index: i,
        id: filteredData[i].id,
        creation_date: filteredData[i].creation_date,
        pallet_number: filteredData[i].pallet_number,
        variety_name: filteredData[i].variety_name,
        condition: filteredData[i].condition,
        lot_number: filteredData[i].lot_number,
        origin_name: filteredData[i].origin_name,
        net_kilograms: filteredData[i].net_kilograms,
        daystay: filteredData[i].daystay,
        inspection,
        color: getBootstrapColorName(inspectionColor),
        potential_kg: potential_kg.toFixed(2),
        potential_percentage: (potentialPercentage * 100).toFixed(2),
        rest: potential_kg.toFixed(2)
      };
      for (let op of opItems) {
        let ponderation = 100;

        // Aplica el filtro de defectos o mas bien caracteristicas
        const defectFilterByOp = defectFilters.find((filt) => filt.op === op.id);
        if (defectFilterByOp) {
          const defectsKeys = defectFilterByOp.defects;
          if (defectsKeys.length > 0) {
            ponderation = 0;
            for (let defectKey of defectsKeys) {
              if (inspection) {
                const value = inspection.data[defectKey];
                if (!isNaN(value)) {
                  ponderation += parseInt(value);
                }
              }
            }
          }
        }

        const op_potential_kg = item["rest"] * (ponderation / 100);
        item["rest"] = (item["rest"] - op_potential_kg).toFixed(2);
        const potential_kg_after_dh = (op_potential_kg * (100 - op.container.dh)) / 100;
        const potential_boxes = Math.floor(potential_kg_after_dh / parseFloat(op.container.net_weight));
        const op_selected_items = op.selected_items;
        item[op.id] = {};
        item[op.id]["potential_kg"] = op_potential_kg.toFixed(2);
        item[op.id]["potential_kg_after_dh"] = potential_kg_after_dh.toFixed(2);
        item[op.id]["potential_boxes"] = potential_boxes;
        item[op.id]["selected"] = op_selected_items ? op_selected_items.includes(item["id"]) : false;
      }
      items.push(item);
    }
    //Sort items by desc daystay
    items.sort((a, b) => {
      return b.daystay - a.daystay;
    });
    resolve(items);
  });
};

export default applyMarketFilters;
